module.exports = __webpack_public_path__ + "img/kitamura.c919a6fd.jpg";